import {
  PURE_DATA_FOR_STRING_REGEX,
  SPECIAL_CHAR_REGEX,
} from "@/constants/regex"
import {
  getLinkFromHref,
  makingTextDatalayerReady,
  pushAnalyticsObjToDataLayer,
  removeAndCleanLink,
} from "@/utils/helper"
import { sanitizedTextAndEntities } from "@/utils/index"
import {
  HOW_TO_BECOME_A_KPN,
  JOIN_NOW,
  TWO_WAYS_TO_BE_A_KPN,
  INSPIRATION_PAGE_NAME,
  BROWSE_ALL_KOHLER_STORES,
  MORE_OPTIONS,
  PAGE_TYPES,
  FIND_A_STORE,
  HERO_BANNER,
} from "@/constants/index"

export const getEventInfo = (
  pageType = "",
  componentPosition = "",
  mainTitle = "",
  eventLabel = "",
  dataLayerLinkType = "",
  eventType = "",
  zone = "",
  parseJson = false
) => {
  const zoneName = zone ? zone?.replace(SPECIAL_CHAR_REGEX, " ") : "zone"
  let internalLinkType = ""
  if (eventLabel === "print") {
    internalLinkType = `${pageType.toLowerCase()}:${mainTitle.toLowerCase()}:print`
  } else {
    internalLinkType = `${dataLayerLinkType}`
  }

  const internalLinkZoneName = zone
    ? `${pageType.toLowerCase()}:${zoneName}`
    : "teaser"

  const eventInfo = {
    clickInternalLinks: "true",
    internalLinkPosition: `${pageType.toLowerCase()}:${
      componentPosition ? componentPosition : "teaser"
    }`,
    internalLinkZoneName,
    internalLinkURL: "n/a",
    internalLinkName: `${eventLabel}`,
    eventName: `${pageType.toLowerCase()}:${
      eventLabel === "print" ? eventLabel : `${zoneName}:share`
    }`,
    internalLinkType: internalLinkType,
    eventType: eventType,
    eventAction: `${pageType.toLowerCase()}:${
      eventLabel === "print" ? eventLabel : `${zoneName}:share`
    }`,
  }
  if (parseJson) {
    return eventInfo
  }
  return JSON.stringify(eventInfo)
}

export const addDatalayerShare = (data = "{}", isPdp = false) => {
  const page = window.pageObj || {}
  const eventInfo = JSON.parse(data)
  const dataLayerObj = {
    event: "cmp:click",
    page,
    eventInfo,
  }
  if (isPdp) {
    const { productInfo } = page
    dataLayerObj["productInfo"] = productInfo
  }
  window.adobeDataLayer.push(dataLayerObj)
}

export const getDownloadEventInfo = (
  downLoadLink = "",
  pageType = "",
  componentPosition = "",
  mainTitle = "",
  dataLayerLinkType = ""
) => {
  let eventInfo = {}
  if (downLoadLink) {
    eventInfo = {
      clickInternalLinks: "true",
      internalLinkPosition: `${pageType.toLowerCase()}:${
        componentPosition ? componentPosition : "teaser"
      }`,
      internalLinkZoneName: "teaser",
      internalLinkURL: `${downLoadLink}`,
      internalLinkName: "download",
      eventName: `${pageType.toLowerCase()}:download`,
      internalLinkType: `${pageType.toLowerCase()}:${mainTitle.toLowerCase()}:download`,
      eventType: "teaser",
      eventAction: `${pageType.toLowerCase()}:download`,
    }
  } else {
    eventInfo = {
      clickInternalLinks: "true",
      internalLinkPosition: `${pageType.toLowerCase()}:${
        componentPosition || "teaser"
      }`,
      internalLinkZoneName: "teaser",
      internalLinkURL: "n/a",
      internalLinkName: "download",
      eventName: `${pageType.toLowerCase()}:download`,
      internalLinkType: `${dataLayerLinkType}`,
      eventType: "teaser",
      eventAction: `${pageType.toLowerCase()}:download`,
    }
  }

  return JSON.stringify(eventInfo)
}

export const getTitleEventInfo = (
  linkNewTab = false,
  componentPosition = "",
  linkURL = "",
  mainTitle = "",
  pageType = "",
  componentLinkType = "",
  title = ""
) => {
  return `{"clickInternalLinks":"${
    linkNewTab || mainTitle.toLowerCase().includes("kohler canada")
      ? "false"
      : "true"
  }","internalLinkPosition":"${pageType?.toLowerCase()}:${
    componentPosition || "teaser"
  }","internalLinkZoneName":"teaser","internalLinkURL":"${
    linkURL || getLinkFromHref(title)
  }","internalLinkName":"${mainTitle.toLowerCase()}","eventName":"${pageType.toLowerCase()}:zone:${mainTitle.toLowerCase()}","internalLinkType":"${pageType}:${
    componentLinkType ? componentLinkType : mainTitle.toLowerCase()
  }","eventType":"teaser","eventAction":"${pageType.toLowerCase()}:zone:${mainTitle.toLowerCase()}"}`
}

export const addTeaserActionAnalytics = ({
  pageType = "",
  componentPosition = "",
  videoTitle = "",
  link = "",
  text = "",
  eventName: eventNameDatalayer,
  dataLayerLinkType = "",
  eventAction: eventActionDataLayer,
  productCategory = "",
  productCollectionsName = "",
  productRoom = "",
  datalayerPageType = "",
  mainTitle = "",
  componentInfo = "",
}) => {
  const eventTitle = makingTextDatalayerReady(mainTitle)
  let internalLinkZoneName
  let eventAction = `${pageType?.toLowerCase()}:${
    eventActionDataLayer?.toLowerCase() || eventTitle || "zone"
  }:${text?.toLowerCase()}`
  let eventName = `${pageType?.toLowerCase()}:${
    eventNameDatalayer?.toLowerCase() || eventTitle || "zone"
  }:${text?.toLowerCase()}`
  if (videoTitle || pageType.toLowerCase() === "plp") {
    eventAction = `${pageType?.toLowerCase()}:${HERO_BANNER}:${text?.toLowerCase()}`
    eventName = `${pageType?.toLowerCase()}:${HERO_BANNER}:${text?.toLowerCase()}`
    internalLinkZoneName = `${pageType.toLowerCase()}:${HERO_BANNER}`
  } else if (eventTitle) {
    internalLinkZoneName = `${pageType.toLowerCase()}:${eventTitle}`
  } else {
    internalLinkZoneName = "teaser"
  }
  let internalLinkPosition = `${pageType?.toLowerCase()}:${
    componentPosition || "teaser"
  }`
  let internalLinkType = `${
    videoTitle.replace(PURE_DATA_FOR_STRING_REGEX, "")
      ? `${pageType.toLowerCase()}:${videoTitle.replace(
          PURE_DATA_FOR_STRING_REGEX,
          ""
        )}`
      : `${pageType.toLowerCase()}:${eventTitle}`
  }`
  if (dataLayerLinkType.includes("social impact")) {
    eventName = `${dataLayerLinkType.substring(
      0,
      dataLayerLinkType.lastIndexOf(":")
    )}:${text?.toLowerCase()}`
    eventAction = `${dataLayerLinkType.substring(
      0,
      dataLayerLinkType.lastIndexOf(":")
    )}:${text?.toLowerCase()}`
    internalLinkZoneName = `${dataLayerLinkType.substring(
      0,
      dataLayerLinkType.lastIndexOf(":")
    )}`
  }
  let eventType = "navigation"
  if (datalayerPageType.includes("locations")) {
    pageType = "locations:kohler stores"
    eventName = `${pageType?.toLowerCase()}:${text?.toLowerCase()}`
    eventAction = `${pageType?.toLowerCase()}:${text?.toLowerCase()}`
    internalLinkZoneName = pageType?.toLowerCase()
    internalLinkPosition = `${pageType?.toLowerCase()}:teaser`
    internalLinkType = `${pageType.toLowerCase()}:${eventTitle}`
  }
  const page = window.pageObj || {}
  if (
    (text === "Get Started" || text === "Apply Now") &&
    eventActionDataLayer === null
  ) {
    const NewDatalayerPageType =
      datalayerPageType === "services"
        ? page?.category?.subCategoryID
        : datalayerPageType
    eventAction = text.toLowerCase()
    eventName = text.toLowerCase()
    eventType = "promo banner"
    internalLinkPosition = `${NewDatalayerPageType?.toLowerCase()}:promo banner`
    internalLinkType = `${pageType.toLowerCase()}:${eventTitle}`
    internalLinkZoneName = `${NewDatalayerPageType?.toLowerCase()}:promo details`
  }
  if (
    (text?.toLowerCase() === BROWSE_ALL_KOHLER_STORES ||
      text === MORE_OPTIONS.LEARN_MORE) &&
    datalayerPageType === "locations"
  ) {
    pageType = `${FIND_A_STORE}:${PAGE_TYPES.LOCATION_LANDING_PAGE}`
    eventName = `${pageType}:${text?.toLowerCase()}`
    eventAction = `${pageType}:${text?.toLowerCase()}`
    internalLinkPosition = FIND_A_STORE
    internalLinkType = `${FIND_A_STORE}:${
      (text === MORE_OPTIONS.LEARN_MORE && eventTitle) || eventType
    }`
    internalLinkZoneName = `${pageType}${
      (text === MORE_OPTIONS.LEARN_MORE && ":" + eventTitle) || ""
    }`
  }
  if (pageType?.toLowerCase() === HOW_TO_BECOME_A_KPN) {
    eventName = `${pageType?.toLowerCase()}:${
      text === JOIN_NOW ? TWO_WAYS_TO_BE_A_KPN : mainTitle?.toLowerCase()
    }:${text.toLowerCase()}`
    eventAction = `${pageType?.toLowerCase()}:${
      text === JOIN_NOW ? TWO_WAYS_TO_BE_A_KPN : mainTitle?.toLowerCase()
    }:${text.toLowerCase()}`
    internalLinkZoneName = `${pageType?.toLowerCase()}:${
      text === JOIN_NOW ? TWO_WAYS_TO_BE_A_KPN : mainTitle?.toLowerCase()
    }`
    eventType = "teaser"
    internalLinkPosition = `${pageType?.toLowerCase()}:teaser`
  }
  const eventInfo = {
    clickInternalLinks:
      link?.startsWith("/") ||
      link?.startsWith("#") ||
      link?.includes(window.location.hostname)
        ? "true"
        : "false",
    internalLinkPosition,
    internalLinkZoneName,
    internalLinkURL: link
      ? `${
          link.indexOf("http") === -1 ? window.location.origin : ""
        }${removeAndCleanLink(link)}`
      : "n/a",
    internalLinkName: `${!text ? "explore more arrow" : text.toLowerCase()}`,
    eventName,
    internalLinkType,
    eventType,
    eventAction,
    eventMsg: "n/a",
    eventStatus: "n/a",
  }

  const customDataLayer = {
    ...(componentInfo ? { componentInfo: JSON.parse(componentInfo) } : {}),
    productInfo: {
      productCategory: productCategory || "n/a",
      productCollectionsName: productCollectionsName || "n/a",
      productRoom: productRoom || "n/a",
    },
  }

  pushAnalyticsObjToDataLayer(eventInfo, "cmp:click", {}, customDataLayer)
}

export const addTeaserDescriptionAnalytic = (
  target = "",
  isPdp = "",
  isPlp = "",
  pageType = "",
  internalLinkPositionNotPdp = "",
  preTitle = "",
  mainTitle = "",
  linkURL = "",
  internalLinkTypeNotPdp = "",
  sanitizeDescription = ""
) => {
  return JSON.stringify({
    clickInternalLinks: target === "_blank" ? "false" : "true",
    internalLinkPosition:
      isPdp || isPlp ? pageType.toLowerCase() : internalLinkPositionNotPdp,
    internalLinkZoneName: isPlp
      ? `${pageType.toLowerCase()}:${preTitle}:rm`
      : mainTitle
      ? `${pageType?.toLowerCase()}:${mainTitle}`
      : "teaser",
    internalLinkURL: linkURL,
    eventName: isPlp
      ? `${pageType.toLowerCase()}:${preTitle}:rm`
      : `${pageType.toLowerCase()}:${mainTitle}:${sanitizeDescription}`,
    internalLinkType: isPdp
      ? `${pageType.toLowerCase()}:teaser`
      : isPlp
      ? `${pageType.toLowerCase()}:navigation`
      : internalLinkTypeNotPdp,
    eventType: isPdp || isPlp ? "navigation" : "teaser",
    internalLinkName: sanitizeDescription,
    eventMsg: "n/a",
    eventStatus: "n/a",
    eventAction: isPlp
      ? `${pageType.toLowerCase()}:${preTitle}:rm`
      : `${pageType.toLowerCase()}:${mainTitle}:${sanitizeDescription}`,
  })
}

export const addTeaserAnalytic = (
  e,
  linkNewTab = false,
  componentPosition = "",
  linkURL = "",
  mainTitle = "",
  pageType = "",
  componentLinkType = "",
  title,
  datalayerLinkName = "",
  containerIdName = "",
  eventName = "",
  eventAction = ""
) => {
  e.preventDefault()
  return `{"clickInternalLinks":"${
    linkNewTab ? "false" : "true"
  }","internalLinkPosition":"${pageType?.toLowerCase()}:${
    componentPosition || "teaser"
  }","internalLinkZoneName":"teaser","internalLinkURL":"${linkURL}","internalLinkName":"${datalayerLinkName}","eventName":"${pageType?.toLowerCase()}:${containerIdName}:${
    eventName || datalayerLinkName || "rm"
  }","internalLinkType":"${pageType}:${
    componentLinkType || mainTitle
  }","eventType":"teaser","eventAction":"${pageType?.toLowerCase()}:${containerIdName}:${
    eventAction || datalayerLinkName || "rm"
  }"}`
}

export const addTeaserLinkAnalytics = (
  link,
  bodytitle,
  containerId,
  data,
  datalayerPageName,
  linkURL
) => {
  const {
    datalayerLinkName,
    fullData,
    mainTitle,
    eventAction,
    eventName,
    linkNewTab,
  } = data
  const page = window.pageObj || {}
  const {
    pageInfo: { pageUrl },
    productInfo,
  } = page
  const pageType = window.eventPageType
  const internalLinkName = sanitizedTextAndEntities(datalayerLinkName)
  if (pageType === "pdp") {
    const eventInfo = {
      eventAction: `pdp:${
        fullData?.teaser?.mainTitle
          ? fullData?.teaser?.mainTitle
          : "product details"
      }:${sanitizedTextAndEntities(eventAction || mainTitle)
        .toLowerCase()
        .trim()}`,
      eventName: `pdp:${
        fullData?.teaser?.mainTitle
          ? fullData?.teaser?.mainTitle
          : "product details"
      }:${sanitizedTextAndEntities(eventName || mainTitle)
        .toLowerCase()
        .trim()}`,
      eventType: "navigation",
      eventMsg: "n/a",
      eventStatus: "n/a",
      internalLinkName,
      internalLinkPosition: "pdp",
      internalLinkType: `pdp:teaser`,
      internalLinkZoneName: `pdp:${sanitizedTextAndEntities(
        fullData?.teaser?.mainTitle || bodytitle
      )
        .toLowerCase()
        .trim()}`,
      internalLinkURL: `${window.location.href || link || pageUrl || "n/a"}`,
      clickInternalLinks: `${linkNewTab ? "false" : "true"}`,
    }
    const dataLayerObj = {
      event: "cmp:click",
      page,
      eventInfo,
      productInfo,
    }
    window.adobeDataLayer.push(dataLayerObj)
  }
  if (pageType === INSPIRATION_PAGE_NAME) {
    const eventInfo = {
      eventAction: `${pageType}:${
        fullData?.teaser?.mainTitle
          ? fullData?.teaser?.mainTitle
          : containerId.replaceAll("-", " ")
      }:${eventAction || mainTitle}`,
      eventName: `${pageType}:${
        fullData?.teaser?.mainTitle
          ? fullData?.teaser?.mainTitle
          : containerId.replaceAll("-", " ")
      }:${eventName || mainTitle}`,
      eventType: "navigation",
      eventMsg: "n/a",
      eventStatus: "n/a",
      internalLinkName: `${datalayerLinkName}`,
      internalLinkPosition: `${pageType}:teaser`,
      internalLinkType: `${pageType}:${containerId.replaceAll("-", " ")}`,
      internalLinkZoneName: `${pageType}:${
        fullData?.teaser?.mainTitle || containerId.replaceAll("-", " ")
      }`,
      internalLinkURL: `${window.location.href || link || pageUrl || "n/a"}`,
      clickInternalLinks: `${linkNewTab ? "false" : "true"}`,
    }
    const dataLayerObj = {
      event: "cmp:click",
      page,
      eventInfo,
    }
    window.adobeDataLayer.push(dataLayerObj)
  }
  if (pageType === "home with shea mcgee") {
    const linkPosition = datalayerPageName.split(":")[0]
    const eventInfo = {
      clickInternalLinks: `${linkNewTab ? "false" : "true"}`,
      internalLinkPosition: linkPosition,
      eventMsg: "n/a",

      internalLinkZoneName: `${pageType}:${linkURL}`,
      internalLinkURL: `${linkURL}`,
      internalLinkName: mainTitle,
      internalLinkType: `${linkPosition}:${pageType}`,
      eventType: "navigation",
      eventAction: `${pageType?.toLowerCase()}:${linkURL}:${mainTitle}`,
      eventName: `${pageType?.toLowerCase()}:${linkURL}:${mainTitle}`,
    }
    const dataLayerObj = {
      event: "cmp:click",
      page,
      eventInfo,
    }
    window.adobeDataLayer.push(dataLayerObj)
  }
}
